module.exports = require("@microsoft/applicationinsights-web");